import Punycode from 'punycode/'
import constants from './../constants.js'

export const parseMailHref = href => {
  let email = href.match(/mailto:([^?]*)/)
  email = email[1] ? email[1] : ''
  let subject = href.match(/subject=([^&]+)/)
  subject = subject ? subject[1].replace(/\+/g, ' ') : ''
  let body = href.match(/body=([^&]+)/)
  body = body ? body[1].replace(/\+/g, ' ').replace(/%0D%0A/g, '\r\n') : ''
  return {
    to: email,
    subject,
    body,
  }
}

export const assembleMailHref = (email, subject, body) => {
  // body をエンコードしない (参考 https://memorva.jp/memo/html/mailto.php
  let href = `mailto:${email}`
  if (subject && body) {
    href += `?subject=${subject}&body=${body}`
  } else if (subject) {
    href += `?subject=${subject}`
  } else if (body) {
    const encodedReturnBody = body.replace(/\r\n|\r|\n/g, '%0D%0A')
    href += `?body=${encodedReturnBody}`
  }
  return href
}

// 文字列 の特定の Index から後の最初もマッチだけその文字を置換する
// (例) body => "test test test", match => "test", replace => "after", fromIndex => 4 結果 "test after test"
export const replaceStringFromSpecifcIndex = (body, match, replace, fromIndex) => {
  const ignoreBody = body.slice(0, fromIndex) // 置換しない文字列
  let replaceBody = body.slice(fromIndex, body.length) // 置換される文字列
  // わざと一度だけ置換している
  const replacedBody = replaceBody.replace(match, replace)
  return ignoreBody + replacedBody
}

// 文字列をDOMオブジェクトに変換
export const stringToHTML = text => {
  if (!text) return [null, null]
  const HTMLObject = new DOMParser().parseFromString(text, 'text/html')
  const HTMLCollection = HTMLObject.body.getElementsByTagName('*')
  return [HTMLObject, HTMLCollection]
}

// リンクに含まれる&の誤変換を防ぐためUUIDに退避
export const getLinkExtractionBody = (text) => {
  let body = JSON.parse(JSON.stringify(text)) // ハードコピー
  // a タグ内の href もしくは img タグ内の src のみ抽出
  // "(href|src)=" までまとめて抽出しているのは、別属性を置換しないようにするため
  const linkRegex = /<(a|img)[^>]*((href|src)=["']?([^"']+)?["']?)[\s\S]*?>/g
  let matches = [...body.matchAll(linkRegex)]

  // リンクオブジェクト生成
  let bodyDiffLength = 0
  let hrefsArray = []
  let srcsArray = []
  matches.forEach(match => {
    const uuid = Math.random().toString(32).substring(2)
    const isAnchorTag = match[1] === 'a'
    const linkString = (isAnchorTag ? 'href="' : 'src="') + uuid + '"'
    body = replaceStringFromSpecifcIndex(
      body,
      match[2],
      linkString,
      match.index - bodyDiffLength
    )
    bodyDiffLength += match[2].length - linkString.length
    if (isAnchorTag) {
      hrefsArray.push({
        uuid: uuid,
        href: match[4]
      })
    } else {
      srcsArray.push({
        uuid: uuid,
        src: match[4]
      })
    }
  })
  return [body, hrefsArray, srcsArray]
}

// UUIDに退避させていたリンクを戻す
export const restoreLinkToBody = (body, hrefsForUuid = [], srcsForUuid = []) => {
  // hrefをUUIDから戻す
  hrefsForUuid.forEach(href => {
    let hrefRegex
    if (href.href === '') {
      // href指定がない場合、href指定ごと削除
      hrefRegex = new RegExp(' href="' + href.uuid + '"', 'g')
      body = body.replace(hrefRegex, '')
    } else {
      // href指定があった場合置き換える
      const hrefRegex = new RegExp(href.uuid, 'g')
      body = body.replace(hrefRegex, href.href)
    }
  })
  // srcをUUIDから戻す
  srcsForUuid.forEach(src => {
    let srcRegex
    if (src.src === '') {
      // src指定がない場合、src指定ごと削除
      srcRegex = new RegExp(' src="' + src.uuid + '"', 'g')
      body = body.replace(srcRegex, '')
    } else {
      // src指定があった場合置き換える
      const srcRegex = new RegExp(src.uuid, 'g')
      body = body.replace(srcRegex, src.src)
    }
  })
  return body
}

export const validateEmail = email => {
  const re = /^([a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+)*)@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  return re.test(email)
}

export const validateTelNumber = telNumber => {
  return /^(\+?)([0-9])+(-[0-9]+)*$/.test(telNumber)
}

export const validateUrl = url => {
  // 参考 https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
  // ドメイン部 https://www.geolocation.co.jp/learn/program/08.html
  // 1文字のドメインラベルを許可 https://stackoverflow.com/questions/2601780/url-valid-characters-java-to-validate
  // path以降は MPのクリックカウントURL抽出の <a>タグ解析パターンを参考に
  // define( "ATAG_PARSER_NOBOX",
  //        "/(<a[\s]+[^<]*?)(href[\s]*=[\s]*)(https?:\/\/[-_.!~*()a-zA-Z0-9;\/?:@&=+$,%#\r\n]+)([^>]*>)([\s\S]*?)(<\/a([^>]*)?>)/i");

  const re = new RegExp('^(https?:\\/\\/)' + // protocol
                        '((((([a-z0-9]|[a-z0-9][a-z0-9-]{0,61}[a-z0-9])\\.)+[a-z]+)|' +
                        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                        '(:\\d+)?)' + // port
                        '(\\/[-_.!~*()a-z0-9;:@&=+$,%\r\n]*)*' + // path
                        '(\\?[-_.!~*()a-z0-9;:@&=+$,%\r\n]*)*' + // query string
                        '(\\#[-_.!~*()a-z0-9;:@&=+$,%\r\n]*)*$', 'i') // fragment locator
  try {
    const encodedUrl = encodeUrl(url)
    return !!re.test(encodedUrl)
  } catch (error) {
    return false
  }
}

export const decodeJwt = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(decodeURIComponent(escape(atob(base64))))
}

export const encodeUrl = url => {
  const punycodedUrl = encodeURIComponentIDN(url)
  // 絵文字・日本語ドメインのpunycode化(通常のURLはスルーする)
  if (punycodedUrl == null || punycodedUrl === '') {
    return ''
  }
  const unicodedUrl = unicodeToURI(punycodedUrl)
  if (unicodedUrl == null || unicodedUrl === '') {
    return ''
  }
  return unicodedUrl
}

// 日本語文字列などをunicodeに変換
export const unicodeToURI = url => {
  return url.replace(/:\/\/([^/|?]+)/, (m0, m1) => {
    const port = m1.match(/(:\d+)/g)
    if (port !== null) {
      const domain = m1.replace(/(:\d+)/g, '')
      return '://' + encodeIDN(domain) + port
    } else {
      return '://' + encodeIDN(m1)
    }
  }).replace(/[^A-Za-z0-9_;/?:@&=+$,[\]\-_.!~*()%#]+/g, (m0) => {
    // 一度デコード
    const tmpURIComponent = decodeURIComponent(m0)
    // unicode に変換
    return encodeURIComponent(tmpURIComponent)
  })
}

// ドメインを punycode にエンコード(変換が必要ない場合はスルーされる)
export const encodeURIComponentIDN = url => {
  return url.replace(/:\/\/([^/|?]+)/, (m0, m1) => {
    // port が指定されている場合の対応
    const port = m1.match(/(:\d+)/g)
    if (port !== null) {
      const domain = m1.replace(/(:\d+)/g, '')
      return '://' + encodeIDN(domain) + port
    } else {
      return '://' + encodeIDN(m1)
    }
  })
}

export const encodeIDN = domain => {
  let words = domain.toLowerCase().split(domainSplitChar)
  for (let i = 0, l = words.length; i < l; i++) {
    if (!words[i].match(/[^0-9a-z-]/)) continue
    words[i] = 'xn--' + Punycode.encode(words[i])
  }
  return words.join('.')
}

// ドメインが絵文字の場合の、tinyMCE と同様の絵文字のエンコード処理
// 参考 http://blog.livedoor.jp/dankogai/archives/51167103.html
// ドメイン内区切文字('.'など)
export const domainSplitChar = new RegExp(
  '[\u002E\u0589\u06D4\u0701\u0702\u1362\u166E\u1803' + '\u1809\u2CF9\u2CFE\u3002\uFE12\uFE52\uFF0E\uFF61]'
)

// base64 encode/decode
// 参考 https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
export const b64Encode = str => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
    return String.fromCharCode('0x' + p1)
  }))
}
export const b64Decode = str => {
  return decodeURIComponent(atob(str).split('').map(c => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

// 参考 https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export const hashCode = s => {
  return s.split('').reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0)
    return a & a
  }, 0)
}

export const hasEditDiff = (state) => {
  if (state.editDiff.isUpdated) return true // 優先的にチェックする
  if (!state.editDiff.storeHashBeforeEdit) return false // 編集データがロードされる前に呼ばれた場合はfalseを返す
  // 比較のためプロパティ定義順を揃える必要がある
  const editStates = {
    contentInfo: state.contentInfo,
    sections: state.sections,
    styles: state.styles,
    mobileStyles: state.mobileStyles,
    originalStyle: state.originalStyle,
    originalHeadStyle: state.originalHeadStyle,
    contentTags: state.contentTags,
  }
  const hash = hashCode(JSON.stringify(editStates))
  return hash !== state.editDiff.storeHashBeforeEdit // ハッシュを比較する
}

export const getVersionInfo = (frontVersion, serverVersion) => {
  const frontV = frontVersion.split('.')
  const serverV = serverVersion.split('.')
  const isLocalStorageUpdate = frontV[0] !== serverV[0] || frontV[1] !== serverV[1]
  const isNoCacheReloadUpdate = isLocalStorageUpdate || frontV[2] !== serverV[2]
  return {
    isLocalStorageUpdate,
    isNoCacheReloadUpdate,
  }
}
// 参考 https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
export const generateRandStr = length => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const generateRandContentId = () => {
  return generateRandStr(50)
}

export const getBeforeDot = str => {
  // .より前を取り出し
  return str.split('.')[0]
}

export const getStrippedImageFilename = filename => {
  // 画像URLから、最後の . からの文字をなくす
  const strippedDotFilename = getBeforeDot(filename)
  // 画像URLから、クエリやハッシュの部分をなくす
  const strippedQueryFilename = strippedDotFilename.split(/[?#]/)[0]
  return strippedQueryFilename
}

// & < > ダブル・シングルクォーテーション を特殊文字に変換
export const sanitizeEncode = (value) => {
  if (!value) return '' // null を返すと、文字列で「null」が表示されてしまう
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

// 改行コードを改行タグに変換
export const sanitizeEncodeBr = (value) => {
  if (!value) return ''
  return value.replace(/\r?\n/g, '<br />')
}

// 特殊文字を対応する記号に変換
// ' PHP側で更新すると&#039;, JS側で更新すると&#39;になるのでどちらのパターンでも置換が必要
export const sanitizeDecode = (value) => {
  if (!value) return null
  return String(value).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#0*39;/g, '\'').replace(/&amp;/g, '&')
}

// 改行タグを改行コードに変換
export const sanitizeDecodeBr = (value) => {
  if (!value) return null
  return value.replace(/<br \/>/g, '\n')
}

// 画像URLバリデーション
export const validateImageUrl = (url) => {
  let errorMessages = []
  if (url == null || url === '') {
    errorMessages.push('参照URLが入力されていません')
  } else {
    if (!validateUrl(url)) {
      errorMessages.push('参照URLの形式が正しくありません')
    }
    if (url.length > constants.maxUrlLength) {
      errorMessages.push('参照URLが長すぎます')
    }
  }
  return errorMessages
}

// ファイル名エンコード
// / が含まれるとファイル名として扱えないので、Base64で未使用の文字列(_)に置換
export const fileNameEncode = (value) => {
  if (!value) return null
  return b64Encode(value).replaceAll('/', '_')
}

export const fileNameDecode = (value) => {
  if (!value) return null
  return b64Decode(value.replaceAll('_', '/'))
}

// 画像ファイル名バリデーション
export const validateImageFilename = (filename) => {
  let errorMessages = []

  if (filename == null || filename === '') {
    errorMessages.push('画像名が入力されていません')
  } else if (filename.length > constants.maxFileNameLength) {
    errorMessages.push('画像名が長すぎます')
  }
  return errorMessages
}

// 画像 alt バリデーション
export const validateImageAlt = (alt) => {
  let errorMessages = []
  if (alt && alt.length > constants.maxAltLength) {
    errorMessages.push('altテキストが長すぎます ※特殊記号は変換後の文字数で計算')
  }
  return errorMessages
}

// リンクバリデーション
export const validateLink = (type, params) => {
  let errorMessages = []
  if (type === 'web') {
    if (params.webLink == null || params.webLink === '') {
      errorMessages.push('URLが入力されていません')
    } else {
      // " ' ` の文字は許可しない
      const unacceptableCharMatch = params.webLink.match(/("|'|`)/)
      if (unacceptableCharMatch && unacceptableCharMatch[1]) {
        errorMessages.push('URL中に ' + unacceptableCharMatch[1] + ' が含まれています、エンコードして入力してください')
      }
      if (params.webLink.length > constants.maxUrlLength) {
        errorMessages.push('URLが長すぎます')
      }
    }
    if (params.webTitle != null && params.webTitle !== '') {
      if (params.webTitle.length > constants.maxTitleLength) {
        errorMessages.push('タイトルが長すぎます')
      }
    }
  }
  if (type === 'email') {
    if (!validateEmail(params.emailTo)) {
      errorMessages.push('メールアドレスの形式が正しくありません')
    }
    if (params.emailTo === '') {
      errorMessages.push('メールアドレスが入力されていません')
    }
    if (params.emailTo.length > constants.maxEmailLength) {
      errorMessages.push('メールアドレスが長すぎます')
    }
    if (params.emailSubject.length > constants.maxEmailSubjectLength) {
      errorMessages.push('メールタイトルが長すぎます')
    }
    if (params.emailBody.length > constants.maxEmailBodyLength) {
      errorMessages.push('メール本文が長すぎます')
    }
  }
  if (type === 'tel') {
    if (params.telNumber == null || params.telNumber === '') {
      errorMessages.push('電話番号が入力されていません')
    } else {
      if (!validateTelNumber(params.telNumber)) {
        errorMessages.push('電話番号が不正な形式です')
      } else {
        const telNumberDigits = params.telNumber.replace(/[^0-9]/g, '').length
        if (telNumberDigits < constants.minTelNumberDigits) {
          errorMessages.push('電話番号が短すぎます')
        }
        if (telNumberDigits > constants.maxTelNumberDigits) {
          errorMessages.push('電話番号が長すぎます')
        }
      }
    }
    if (params.telTitle != null && params.telTitle !== '') {
      if (params.telTitle.length > constants.maxTitleLength) {
        errorMessages.push('タイトルが長すぎます')
      }
    }
  }
  return errorMessages
}
